<template>
  <div class="padding width-100 min-height bg-image" style="background-color: #f6f6f6">
    <div style="height: 80px" class="margin-bs flex-column align-items-star justify-content-center margin-t">
      <div class="flex-row align-items-center justify-content-start">
        <div
          class="margin-r bg-date flex-column align-items-center justify-content-around"
          style="height: 2.5rem; width: 2.5rem"
          @click="show = true"
        >
          <div style="height: 1rem" class="flex-row align-items-center justify-content-center">
            <div class="white fm-sh-regular width-100 fs-sml">{{ year }}</div>
          </div>
          <div class="flex-row align-items-end justify-content-center" style="height: 1.5rem">
            <div class="white fm-sh-bold fs-20 fw-mid line-height" style="color: #1e67f7">{{ month2 }}</div>
            <div class="white fm-sh-regular fs-sml" style="color: #1e67f7; line-height: 1rem">月</div>
          </div>
        </div>
        <van-image :src="require('../assets/image/leaderboard/title.png')" fit="contain" width="40%" />
      </div>
    </div>
    <div class="flex-column align-items-center justify-content-start width-100 bg-white br-reg" style="padding: 0 5%">
      <!-- <div class="grey fs-sml fm-x margin-ts">排行榜数据每30秒更新一次</div> -->
      <div class="width-100 flex-column align-items-center justify-content-start margin-t">
        <div class="flex-row width-100 align-items-center justify-content-spaceBetween br-big">
          <div style="color: #265df2" class="fw-mid textAlign-c width-30 fm-sh-bold fs-mid-sml canNotWrap">日期</div>
          <div style="color: #265df2" class="fw-mid width-20 textAlign-c fm-sh-bold fs-mid-sml canNotWrap">转发</div>
          <div style="color: #265df2" class="fw-mid width-20 textAlign-c fm-sh-bold fs-mid-sml canNotWrap">点赞</div>
          <div style="color: #265df2" class="fw-mid width-20 textAlign-c fm-sh-bold fs-mid-sml canNotWrap">评论</div>
        </div>
        <van-list v-model="loading" :finished="finished" :finished-text="list.length == 0 ? '' : '没有更多了'" @load="onLoad" class="width-100">
          <div
            v-for="(item, key) in list"
            :key="key"
            class="flex-row width-100 align-items-center justify-content-spaceBetween padding-Tb-20"
            style="border-bottom: 1px dashed #979797"
          >
            <div class="textAlign-c width-30 fs-sml">{{ item.cre_date }}</div>
            <div class="width-20 textAlign-c fm-sh-regular fs-sml canNotWrap show-line-1">+{{ item.task_effective_forward_num }}</div>
            <div class="width-20 textAlign-c fm-sh-regular fs-sml canNotWrap show-line-1">+{{ item.task_effective_like_num }}</div>
            <div class="width-20 textAlign-c fm-sh-regular fs-sml canNotWrap show-line-1">+{{ item.task_effective_comment_num }}</div>
          </div>
          <van-empty
            v-if="list.length == 0"
            class="custom-image"
            :image="require('../assets/image/prizeManagement/empty-image.png')"
            description="暂无数据"
          />
        </van-list>
      </div>
    </div>
    <div style="margin-bottom: 80px"></div>
    <van-overlay :show="show" class="flex-column align-items-center justify-content-end">
      <!-- <van-picker
        title="选择月份"
        show-toolbar
        :default-index="month2 - 1"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="show = false"
        class="width-100"
        style="z-index: 9999"
      /> -->
      <van-datetime-picker
        @confirm="onConfirm"
        @cancel="show = false"
        class="width-100"
        style="z-index: 9999"
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
      />
    </van-overlay>
  </div>
</template>

<script>
import { get_member_day_task_info } from '../api/leaderboard.js';
export default {
  data() {
    return {
      show: false,
      active: 0,
      loading: false,
      finished: true,
      year: 0,
      month: '2023-08-01',
      month2: 1,
      list: [],
      minDate: new Date(2023, 0, 1),
      maxDate: new Date(),
      dept_info: { id: null, name: '', score: '0', ranking_num: '0' },
      columns: [
        { text: '1月', value: 1 },
        { text: '2月', value: 2 },
        { text: '3月', value: 3 },
        { text: '4月', value: 4 },
        { text: '5月', value: 5 },
        { text: '6月', value: 6 },
        { text: '7月', value: 7 },
        { text: '8月', value: 8 },
        { text: '9月', value: 9 },
        { text: '10月', value: 10 },
        { text: '11月', value: 11 },
        { text: '12月', value: 12 }
      ]
    };
  },
  beforeMount() {
    let date = new Date();
    this.year = date.getFullYear();
    this.month2 = date.getMonth() + 1;
    this.month = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.getList();
  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val * 1}月`;
      }
      return val * 1;
    },
    onLoad() {
      const _this = this;
      setTimeout(() => {
        console.log(12);
        _this.loading = false;
      }, 2000);
    },
    onConfirm(key) {
      let date = new Date(key);
      this.month2 = date.getMonth() + 1;
      this.year = date.getFullYear();
      this.month = date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1) + '-' + date.getDate();
      this.getList();
      this.show = false;
    },
    async getList() {
      this.loading = true;
      this.list = [];
      await get_member_day_task_info({ month: this.month })
        .then((res) => {
          if (res.code == 0) {
            this.list = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.bg-image {
  background-image: url('../assets/image/leaderboard/bg.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
.bg-title {
  background-image: url('../assets/image/leaderboard/bg1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 4rem;
  position: relative;
}
.bg-date {
  height: 25px;
  width: 25px;
  background-image: url('../assets/image/leaderboard/calendar.png');
  background-size: 100% 100%;
}
.active-tag {
  color: white;
  background: #1e67f7;
  border-radius: 1.25rem;
  font-size: 14px;
  height: 28px;
  line-height: 28px;
}
.normal-tag {
  color: #1e67f7;
  font-size: 14px;
  height: 28px;
  line-height: 28px;
}
.bg-ranking {
  position: absolute;
  right: 10%;
  top: 0;
  background-image: url('../assets/image/leaderboard/rank.png');
  background-size: 100% 100%;
  width: 50px;
  height: 50px;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
::v-deep .van-overlay {
  z-index: 1000 !important;
}
</style>
